<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 1000 1000"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="9" y="9" width="982" height="982" rx="258" fill="#122733" />
    <rect
      x="109.47"
      y="186"
      width="510.397"
      height="114.075"
      rx="57.0375"
      fill="#3E4A4E"
    />
    <rect
      x="395.245"
      y="699.925"
      width="496.285"
      height="114.075"
      rx="57.0375"
      fill="#3E4A4E"
    />
    <rect
      x="650.444"
      y="525.873"
      width="241.086"
      height="114.075"
      rx="57.0375"
      fill="#3E4A4E"
    />
    <rect
      x="381.133"
      y="351.82"
      width="510.397"
      height="114.075"
      rx="57.0375"
      fill="#1BF264"
    />
    <rect
      x="109.47"
      y="525.873"
      width="496.285"
      height="114.075"
      rx="57.0375"
      fill="#1BBFF2"
    />
    <rect
      x="650.444"
      y="186"
      width="241.086"
      height="114.075"
      rx="57.0375"
      fill="#EDEFEF"
    />
    <rect
      x="109.47"
      y="351.82"
      width="241.086"
      height="114.075"
      rx="57.0375"
      fill="#F7F4F6"
    />
    <rect
      x="109.47"
      y="699.925"
      width="241.086"
      height="114.075"
      rx="57.0375"
      fill="#F7F4F6"
    />
  </svg>
</template>

<script>
export default {
    props: {
        size: {
            type: [String, Number],
            default: "30"
        }
    }
};
</script>

<style></style>
